import axios from 'axios';
import prepareRequestOptions from '../utils/admin-apis.util';

export const getListData = async (id, params = '', signal = null) => {
  const options = prepareRequestOptions(
    `/admin/channel/${id}/packages/list${params}`,
    'GET',
    null,
    true,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const createNewData = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/channel/packages/create',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const createNewDefaultPackages = async (channelId) => {
  const options = prepareRequestOptions(
    `/admin/channel/${channelId}/packages/create-default`,
    'POST',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const viewDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/channel/packages/${id}/view`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const updateDataById = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/channel/packages/${id}/update`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const deleteDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/channel/packages/${id}/delete`,
    'DELETE',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};
